export const LocalStorage = () => {
  const store = (
    key: string,
    value: string | object | Array<string | object> | boolean
  ) => {
    localStorage.setItem(key, JSON.stringify(value))
  }

  const retrieve = (key: string) => {
    const value = localStorage.getItem(key)

    try {
      return value ? JSON.parse(value) : value
    } catch (_probablyAJsonParseError) {
      return value
    }
  }

  const remove = (key: string) => {
    localStorage.removeItem(key)
  }

  const clear = () => {
    localStorage.clear()
  }

  return { store, retrieve, remove, clear }
}
